<template>
  <div
    class="ws-block-btn"
    v-ripple="_ripple"
    :class="[{active:active}]"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _ripple() {
      if (this.disabled) {
        return null;
      } else {
        return { class: "buttonRipple--text" };
      }
    }
  }
};
</script>

<style>
</style>